
import { createTheme } from '@mui/material/styles';
// v7부터 koKR이 @mui/x-data-grid 본체가 아니라 /locales 하위로 옮겨졌다(그대로 쓰면 undefined).
import { koKR } from '@mui/x-data-grid/locales';
import { koKR as corekoKR } from '@mui/material/locale';



const theme = createTheme(
    {
        typography: {
            fontFamily: [
                'Noto Sans CJK KR',
            ].join(','),
        },
        palette: {
            default: {
                dark: '#000000',
                light: '#111111',
                main: '#100008',
                contrastText: '#ffffff',
            },

        },

        components: {
            // 휴대폰(600px 미만)에서 대화상자: 화면 가장자리 여백이 커서 본문이 좁고, 하단 버튼이 세로로
            // 쌓이며 안내 문구와 겹쳐 잘렸다(2026-10-15 실기기, 견적서 상세). 휴대폰에서는 화면 꽉 차게,
            // 하단 버튼 줄은 줄바꿈되게 하고 버튼은 반씩 나눠 쓴다.
            MuiDialog: {
                styleOverrides: {
                    paper: {
                        '@media (max-width: 599.95px)': {
                            margin: 8,
                            width: 'calc(100% - 16px)',
                            maxWidth: 'calc(100% - 16px) !important',
                            maxHeight: 'calc(100% - 16px)',
                        },
                    },
                },
            },
            MuiDialogActions: {
                styleOverrides: {
                    root: {
                        '@media (max-width: 599.95px)': {
                            flexWrap: 'wrap',
                            gap: 8,
                            padding: '8px 12px calc(8px + env(safe-area-inset-bottom, 0px))',
                            '& > :not(style) ~ :not(style)': { marginLeft: 0 },
                            '& > .MuiButton-root': { flex: '1 1 calc(50% - 8px)', minHeight: 40 },
                            // 버튼이 아닌 안내 문구·버튼 묶음(Box)은 한 줄 전체를 쓴다
                            '& > :not(.MuiButton-root)': { flex: '1 1 100%' },
                            // Box 로 묶인 버튼들(견적서 상세의 PDF 미리보기/다운로드/엑셀 등)도 한 줄에 나눠 담는다
                            '& > .MuiBox-root': { display: 'flex', flexWrap: 'wrap', gap: 8 },
                            '& > .MuiBox-root > .MuiButton-root': { flex: '1 1 calc(33% - 8px)', margin: 0, minHeight: 40 },
                        },
                    },
                },
            },
            MuiDialogTitle: {
                styleOverrides: {
                    root: {
                        '@media (max-width: 599.95px)': {
                            fontSize: '1.05rem',
                            padding: '12px 44px 8px 16px',
                        },
                    },
                },
            },
            MuiCssBaseline: {
                styleOverrides: {
                    // 목록 위 상태 칩 묶음(*StatusList, className="status-chip-list"). 휴대폰에서는 칩이
                    // 한 줄에 1~2개씩 쌓여 세로로 길어졌다(2026-10-08 사용자 지적). 묶음마다 한 줄로 두고
                    // 옆으로 밀어서 보게 한다. 묶음 사이 세로 구분선은 숨긴다.
                    '@media (max-width: 599.95px)': {
                        '.status-chip-list': {
                            justifyContent: 'flex-start !important',
                            margin: '4px 0 !important',
                            width: '100%',
                        },
                        // 2026-10-15: 묶음마다 한 줄씩 쌓던 것을 묶음 전체 한 줄로 바꿨다(칩도 작게). 넘치면 옆으로 밀어서 본다.
                        '.status-chip-list > .MuiStack-root': {
                            flexDirection: 'row !important',
                            flexWrap: 'nowrap',
                            overflowX: 'auto',
                            scrollbarWidth: 'none',
                            width: '100%',
                            gap: '10px',
                        },
                        '.status-chip-list > .MuiStack-root > *': {
                            marginLeft: '0 !important',
                            marginTop: '0 !important',
                        },
                        '.status-chip-list > .MuiStack-root > *': {
                            flexShrink: 0,
                        },
                        '.status-chip-list > .MuiStack-root > hr': {
                            display: 'block',
                            margin: '4px 0 !important',
                        },
                        '.status-chip-list div:has(> .MuiChip-root)': {
                            display: 'flex',
                            flexWrap: 'nowrap !important',
                            flexShrink: 0,
                            gap: '6px',
                            margin: '0 !important',
                            paddingBottom: '2px',
                            scrollbarWidth: 'none',
                        },
                        // 데스크톱 기준으로 xs 칸(1~5/12)만 정해 둔 입력폼(예: 계약 상세 "기본사항")은 휴대폰에서
                        // 이름표가 한 글자씩 세로로 서고 입력칸이 눌렸다(2026-10-08 상세 화면 점검). sm·md·lg 를 따로
                        // 정한 칸은 휴대폰용 배치를 이미 가진 것이라 건드리지 않고, xs 만 있는 좁은 칸만 한 줄을 다 쓰게 한다.
                        // 이 처리를 원치 않는 곳은 바깥에 className="no-mobile-stack" 을 붙인다.
                        ':not(.no-mobile-stack) > .MuiGrid-container > .MuiGrid-item:is(.MuiGrid-grid-xs-1, .MuiGrid-grid-xs-2, .MuiGrid-grid-xs-3, .MuiGrid-grid-xs-4, .MuiGrid-grid-xs-5):not([class*="MuiGrid-grid-sm-"]):not([class*="MuiGrid-grid-md-"]):not([class*="MuiGrid-grid-lg-"]):not([class*="MuiGrid-grid-xl-"])': {
                            flexBasis: '100%',
                            maxWidth: '100%',
                        },
                        // 상세 화면 위 요약표(제목 줄 + 값 줄 두 줄짜리 Grid, className="summary-grid-table").
                        // 칸이 좁아 프로젝트 번호와 매출처가 포개졌다. 휴대폰에서는 "이름표 | 값" 두 칸 목록으로 바꾼다:
                        // 두 줄을 display: contents 로 풀고, n번째 제목은 n번째 줄 왼쪽, n번째 값은 n번째 줄 오른쪽에 둔다.
                        '.summary-grid-table': {
                            display: 'grid !important',
                            gridTemplateColumns: 'max-content minmax(0, 1fr)',
                            columnGap: '12px',
                            rowGap: '6px',
                            padding: '12px 16px !important',
                        },
                        '.summary-grid-table > .MuiGrid-container': {
                            display: 'contents',
                        },
                        '.summary-grid-table > .MuiGrid-container > .MuiGrid-item': {
                            maxWidth: 'none !important',
                            flexBasis: 'auto !important',
                            textAlign: 'left !important',
                            wordBreak: 'keep-all',
                            overflowWrap: 'anywhere',
                        },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(1) > .MuiGrid-item .MuiTypography-root': {
                            color: 'rgba(0,0,0,0.6)',
                            whiteSpace: 'nowrap',
                        },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(1) > .MuiGrid-item:nth-of-type(1)': { gridColumn: 1, gridRow: 1 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(2) > .MuiGrid-item:nth-of-type(1)': { gridColumn: 2, gridRow: 1 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(1) > .MuiGrid-item:nth-of-type(2)': { gridColumn: 1, gridRow: 2 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(2) > .MuiGrid-item:nth-of-type(2)': { gridColumn: 2, gridRow: 2 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(1) > .MuiGrid-item:nth-of-type(3)': { gridColumn: 1, gridRow: 3 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(2) > .MuiGrid-item:nth-of-type(3)': { gridColumn: 2, gridRow: 3 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(1) > .MuiGrid-item:nth-of-type(4)': { gridColumn: 1, gridRow: 4 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(2) > .MuiGrid-item:nth-of-type(4)': { gridColumn: 2, gridRow: 4 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(1) > .MuiGrid-item:nth-of-type(5)': { gridColumn: 1, gridRow: 5 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(2) > .MuiGrid-item:nth-of-type(5)': { gridColumn: 2, gridRow: 5 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(1) > .MuiGrid-item:nth-of-type(6)': { gridColumn: 1, gridRow: 6 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(2) > .MuiGrid-item:nth-of-type(6)': { gridColumn: 2, gridRow: 6 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(1) > .MuiGrid-item:nth-of-type(7)': { gridColumn: 1, gridRow: 7 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(2) > .MuiGrid-item:nth-of-type(7)': { gridColumn: 2, gridRow: 7 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(1) > .MuiGrid-item:nth-of-type(8)': { gridColumn: 1, gridRow: 8 },
                        '.summary-grid-table > .MuiGrid-container:nth-of-type(2) > .MuiGrid-item:nth-of-type(8)': { gridColumn: 2, gridRow: 8 },
                        '.status-chip-list .MuiChip-root': {
                            marginRight: '0 !important',
                            flexShrink: 0,
                            height: 28,
                            fontSize: 13,
                        },
                        '.status-chip-list .MuiChip-root .MuiChip-icon': {
                            fontSize: 16,
                        },
                        '.status-chip-list .MuiChip-root .MuiChip-label': {
                            paddingLeft: 8,
                            paddingRight: 10,
                        },
                        // 목록 검색줄(검색어 입력이 있는 form)의 테두리형 입력(=날짜칸): 휴대폰에서는 작은 칸(높이 40)으로.
                        // 상세 입력폼은 건드리지 않도록 searchWords 입력이 있는 form 안으로만 한정한다.
                        // (휴대폰에서는 달력 아이콘 없는 모바일 날짜선택기가 떠서 아이콘으로는 못 고른다)
                        'form:has(input[name="searchWords"]) .MuiOutlinedInput-input': {
                            paddingTop: '8.5px',
                            paddingBottom: '8.5px',
                            fontSize: 14,
                        },
                        'form:has(input[name="searchWords"]) .MuiFormControl-root:has(> .MuiOutlinedInput-root)': {
                            marginTop: '10px',
                            width: '100%',
                        },
                        'form:has(input[name="searchWords"]) .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                            fontSize: 14,
                        },
                    },
                    '*': {
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#B7B7B7 transparent',
                        '&::-webkit-scrollbar': {
                            width: 6,
                            height: 6,
                            backgroundColor: 'transparent',
                        },
                        '&::-webkit-scrollbar-track': {
                            // backgroundColor: 'transparent',
                            borderRadius: 6,
                            background: "rgba(0,0,0,.1)",
                        },
                        '&::-webkit-scrollbar-thumb': {
                            borderRadius: 6,
                            background: "rgba(0,0,0,.2)",
                            // minHeight: 24,
                            // minWidth: 24,
                        },
                        '&::-webkit-scrollbar-thumb:focus': {
                            //backgroundColor: '#adadad',
                            background: "rgba(0,0,0,.2)"
                        },
                        '&::-webkit-scrollbar-thumb:active': {
                            background: "rgba(0,0,0,.2)"
                        },
                        '&::-webkit-scrollbar-thumb:hover': {
                            background: "rgba(0,0,0,.2)"
                        },
                        '&::-webkit-scrollbar-corner': {
                            backgroundColor: 'transparent',
                        },
                    },
                },
            },

            // 표의 한 칸은 세로 가운데로 맞춘다.
            //
            // DataGrid v7 의 칸은 block 이라 세로 정렬을 해주는 것이 없다. 그래서 값만 찍는 칸은
            // 가운데로 보이는데 renderCell 로 직접 그린 칸(칩·아이콘·굵은 글씨 따위)만 위에 붙어,
            // 같은 줄인데 글자 높이가 어긋난다.
            //
            // 화면마다 따로 넣다 보니 몇 군데만 맞고 나머지는 틀어져 있었다. 여기서 한 번에 맞춘다.
            // 여러 줄짜리 칸(getRowHeight='auto')을 쓰는 표는 지금 하나도 없어서 이렇게 둬도 된다.
            // 나중에 그런 표가 생기면 그 표에서만 alignItems 를 되돌리면 된다.
            // 휴대폰 폭에서는 표 칸 글자를 줄바꿈하지 않는다. 통계표 칸이 좁아 "매출액"이 한 글자씩 세로로
            // 꺾였다(2026-10-08 모바일 점검). 대신 표는 가로로 밀어서 본다(TableContainer 가 스크롤을 맡는다).
            MuiTableCell: {
                styleOverrides: {
                    root: ({ theme: t }) => ({
                        [t.breakpoints.down('sm')]: {
                            whiteSpace: 'nowrap',
                        },
                    }),
                },
            },
            // 휴대폰에서 누르는 칩(필터 칩·이어서 묻기 칩)은 손가락으로 누를 만큼 키운다(작은 칩은 24px).
            MuiChip: {
                styleOverrides: {
                    root: ({ ownerState, theme: t }) => ((ownerState.clickable || ownerState.onClick) ? {
                        [t.breakpoints.down('sm')]: {
                            minHeight: 32,
                        },
                    } : {}),
                },
            },
            // 휴대폰에서 버튼 글자가 한 글자씩 꺾이지 않게 한다("엑셀 다운로드"가 4줄이 됐다).
            MuiButton: {
                styleOverrides: {
                    root: ({ theme: t }) => ({
                        [t.breakpoints.down('sm')]: {
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                        },
                    }),
                },
            },
            MuiTableContainer: {
                styleOverrides: {
                    root: ({ theme: t }) => ({
                        [t.breakpoints.down('sm')]: {
                            overflowX: 'auto',
                        },
                    }),
                },
            },
            MuiDataGrid: {
                styleOverrides: {
                    cell: {
                        display: 'flex',
                        alignItems: 'center',
                    },
                },
            },

        },

    },

    koKR,
    corekoKR,
);
export default theme